import { PropsWithChildren } from 'react';
import { Button, Icon, IconName } from 'react-frontier';
import { useNavigate, useLocation } from 'react-router-dom';
import { CDN_URL } from './API';
import { useUser } from './hooks';

interface SidebarItem{
	icon: IconName;
	label: string;
	path: string;
}

const SIDEBAR_ITEMS: SidebarItem[] =[
	{ icon: 'clock', label: 'Check', path: '/check' },
	{ icon: 'user', label: 'Perfil', path: '/profile' }
];

var TeamContainer =({ children }: PropsWithChildren)=>{
	var { user, logout } = useUser();
	var navigate = useNavigate();
	var location = useLocation();

	var isItemActive =(item: SidebarItem)=>{
		if(item.path === '/check') return location.pathname === '/check';
		return location.pathname === item.path || location.pathname.startsWith(`${item.path}/`);
	};

	if(!user) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#f0f0f0' }}>
		<img src={`${CDN_URL}/logo/LogoH_Large.webp`} alt="AREMA" style={{ borderRadius: 4, width: 100, height: 100, objectFit: 'contain' }} />
	</div>

	return <>
		<nav className="team-navbar">
			<div className="team-navbar-inner">
				<img className="team-navbar-logo" src="https://cdn.arema.dev/assets/favicon.png" alt="AREMA" />
				<span className="team-navbar-user">{user.first_name} {user.last_name}</span>
				<Button type="button" text='Cerrar sesión' basic size='small' iconName="sign-out-alt" nativeOnClick={logout} />
			</div>
		</nav>
		<div className="team-layout">
			<aside className="team-sidebar">
				{SIDEBAR_ITEMS.map(item=>(
					<button
						key={item.path}
						className={`team-sidebar-btn${isItemActive(item) ? ' active' : ''}`}
						title={item.label}
						onClick={()=>navigate(item.path)}
					>
						<Icon name={item.icon} style={{ margin: 0 }} />
						<span>{item.label}</span>
					</button>
				))}
			</aside>
			<div className="team-layout-content">
				{children}
			</div>
		</div>
		<div className="team-bottombar">
			{SIDEBAR_ITEMS.map(item=>(
				<button
					key={item.path}
					className={`team-bottombar-btn${isItemActive(item) ? ' active' : ''}`}
					onClick={()=>navigate(item.path)}
				>
					<Icon name={item.icon} size={20} style={{ margin: 0 }} />
					<span>{item.label}</span>
				</button>
			))}
		</div>
	</>;
};

export default TeamContainer;
